import { createSlice } from '@reduxjs/toolkit'

// initial fees collection form
export const initialFeesCollectionForm={
  date:"",
  student_id:"",
  class_id:"",
  payment_mode:"",
  amount:"",
}

export const feesOverview=createSlice({
    name:"feesOverview",
    initialState: {
        popup:{
            feesCollectionPopup:false,
            feesApprovalPopup:false
        },
        form:{
          feesCollectionForm:initialFeesCollectionForm
        }
    },
    reducers:{
      // dispatch action for popup
      openFeesCollectionPopup : (state) =>{
        state.popup.feesCollectionPopup = true
      },
      closeFeesCollectionPopup : (state) =>{
        state.popup.feesCollectionPopup = false
      },

      // dispatch action for form
      addFeesCollectionForm : (state, action) =>{
        state.form.feesCollectionForm = action.payload
      },
      openFeesApprovalPopup : (state, action) =>{
        state.popup.feesApprovalPopup = true;
        state.form.feesCollectionForm = action.payload
    },
      closeFeesApprovalPopup : (state) =>{
        state.popup.feesApprovalPopup = false
      },
  }
})

export const {openFeesCollectionPopup, closeFeesCollectionPopup, addFeesCollectionForm, openFeesApprovalPopup, closeFeesApprovalPopup}=feesOverview.actions

// popup state
export const getFeesCollectionPopup=(state)=>state.feesOverview.popup.feesCollectionPopup
export const getFeesApprovalPopup=(state)=>state.feesOverview.popup.feesApprovalPopup
//form state
export const getFeesCollectionForm=(state)=>state.feesOverview.form.feesCollectionForm

export default feesOverview.reducer